// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartCustomTooltip_wrapper__7ssLv"};